import { CrudEndpoint } from './crud.endpoint';

export class SourcesEndpoint extends CrudEndpoint {
	constructor() {
		super('sources');
	}
}
